import { Component, Input, OnInit } from '@angular/core';
import { PartnerInfoInterface } from 'src/app/share/interface/partner.interface';
import { SocialMediaList } from 'src/app/share/service/footer.service';

@Component({
  selector: 'app-kopetro-footer',
  templateUrl: './kopetro-footer.component.html',
  styleUrls: ['./kopetro-footer.component.scss']
})
export class KopetroFooterComponent  {
  @Input() info: PartnerInfoInterface;
  @Input() socialMediaList: SocialMediaList[];
  
  constructor() { }

}
